export const incoming = {
  PLAYBACK: "playback",
  QUEUE: "queue",
  PARTY: "party",
  MESSAGE: "message",
  VOTE: "vote",
  NOT_AUTHORIZED: "notAuthorized",
  NO_DEVICE: "noDevice",
  ERROR: "error",
  NEXT_SONG: "nextSong",
  ACK_JOIN_PARTY: "ackJoinParty",
  VOTES: "votes",
  STOP: "stop",
};

export const outgoing = {
  JOIN_PARTY: "joinParty",
  MESSAGE: "message",
};
